import { GREAT_WHITE, OLAF } from 'visitor-ui-component-library/constants/WidgetColors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRef } from 'react';
import styled, { css } from 'styled-components';
import SVGChat from 'visitor-ui-component-library-icons/icons/SVGChat';
import SVGKnowledgeBase from 'visitor-ui-component-library-icons/icons/SVGKnowledgeBase';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { KNOWLEDGE_BASE, THREAD_LIST } from '../constants/views';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavigationWrapper = styled.div.withConfig({
  displayName: "KBNavigation__NavigationWrapper",
  componentId: "u2r6ay-0"
})(["height:72px;width:100%;display:flex;justify-content:center;align-items:center;gap:8px;border-top:1px solid ", ";box-shadow:rgba(0,0,0,0.05) 0px 0px 16px;"], GREAT_WHITE);
const NavigationButton = styled.button.withConfig({
  displayName: "KBNavigation__NavigationButton",
  componentId: "u2r6ay-1"
})(["display:flex;gap:5px;border:none;background-color:", ";padding:0;width:96px;height:48px;align-items:center;justify-content:center;outline:none;color:", ";transition:all 0.3s ease;font-size:14px;border-radius:10px;font-weight:600;&:hover:enabled{", "}"], ({
  theme,
  active
}) => active ? theme.colors.primary : OLAF, ({
  theme,
  active
}) => active ? OLAF : theme.colors.primary, ({
  active,
  theme
}) => css(["background-color:", ";color:", ";"], active ? adjustLuminance(theme.colors.primary, 10) : theme.colors.primary, OLAF));
const KBNavigation = ({
  view,
  updateView,
  inPreview = false
}) => {
  const selectChatButton = useRef(null);
  const selectKBButton = useRef(null);
  const handleKeyDown = event => {
    if (event.key === 'ArrowRight') {
      updateView(KNOWLEDGE_BASE);
      if (selectKBButton !== null && selectKBButton !== void 0 && selectKBButton.current) {
        selectKBButton.current.focus();
      }
    }
    if (event.key === 'ArrowLeft') {
      updateView(THREAD_LIST);
      if (selectChatButton !== null && selectChatButton !== void 0 && selectChatButton.current) {
        selectChatButton.current.focus();
      }
    }
  };
  return /*#__PURE__*/_jsxs(NavigationWrapper, {
    role: "tablist",
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorWidget.navigation.kbNavigation'),
    children: [/*#__PURE__*/_jsxs(NavigationButton, {
      active: !view || view === THREAD_LIST,
      "aria-selected": view === THREAD_LIST,
      disabled: inPreview,
      onClick: () => updateView(THREAD_LIST),
      onKeyDown: handleKeyDown,
      role: "tab",
      ref: selectChatButton,
      children: [/*#__PURE__*/_jsx(VizExIcon, {
        "aria-hidden": "true",
        icon: /*#__PURE__*/_jsx(SVGChat, {
          height: 24,
          width: 24
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.visitorWidget.navigation.options.chat"
      })]
    }), /*#__PURE__*/_jsxs(NavigationButton, {
      active: view === KNOWLEDGE_BASE,
      "aria-selected": view === KNOWLEDGE_BASE,
      disabled: inPreview,
      onClick: () => updateView(KNOWLEDGE_BASE),
      onKeyDown: handleKeyDown,
      role: "tab",
      ref: selectKBButton,
      children: [/*#__PURE__*/_jsx(VizExIcon, {
        "aria-hidden": "true",
        icon: /*#__PURE__*/_jsx(SVGKnowledgeBase, {
          height: 24,
          width: 24
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.visitorWidget.navigation.options.help"
      })]
    })]
  });
};
KBNavigation.displayName = 'KBNavigation';
export default KBNavigation;